"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToleranceIcon = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const Icons_1 = require("../Icons");
const svgData_1 = require("./svgData");
const ToleranceIcon = ({ size = 16, type = "" }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(Icons_1.Base, { size: size, title: type, fill: theme.icon, smooth: true }, svgData_1.data[type]));
};
exports.ToleranceIcon = ToleranceIcon;
exports.default = exports.ToleranceIcon;
//# sourceMappingURL=index.js.map